import _ from 'lodash'
import {setters} from 'src/helpers'
import Button from './Button'


export default class Slide {
  // title
  // subtitle
  // image
  // image_link
  // buttons

  constructor(initObject = {}) {
    const {title, subtitle, image, image_link, buttons} = initObject
    this.title = title
    this.subtitle = subtitle
    this.image = image
    this.image_link = image_link
    this.buttons = _.map(buttons, b => new Button(b))
  }

  set title(text) { setters.string.call(this, '_title', text) }
  get title() { return this._title }

  set subtitle(text) { setters.string.call(this, '_subtitle', text) }
  get subtitle() { return this._subtitle }

  set image(url) { setters.string.call(this, '_image', url) }
  get image() { return this._image }

  set image_link(url) { setters.string.call(this, '_image_link', url) }
  get image_link() { return this._image_link }

  set buttons(buttons) { setters.arrayOfType.call(this, '_buttons', buttons, Button) }
  get buttons() { return this._buttons.map(btn => btn.toJSON()) }

  toJSON = () => {
    return {
      title: this.title,
      subtitle: this.subtitle,
      image: this.image,
      image_link: this.image_link,
      buttons: this.buttons
    }
  }
}


// WEBPACK FOOTER //
// ./src/App/services/types/Slide.js